export default __webpack_public_path__ + "static/champaka-955ae0d573613655c6744d5ba3440137.png";